// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { FacilityModel } from '../_models/facility.model';
import { FacilitiesState } from '../_reducers/facility.reducers';

// createFeatureSelector define all state with the reducers defined ,
export const selectFacilitiesState = createFeatureSelector<FacilitiesState>('facilities');

// createSelector : to create selector take all state of this reducer = FEATURESELECTOR and return a peice of state
export const selectFacilityById = (facility_id: number) =>
  createSelector(selectFacilitiesState, (facilitiesState) => facilitiesState.entities[facility_id]);

export const selectFacilitiesPageLoading = createSelector(
  selectFacilitiesState,
  (facilitiesState) => facilitiesState.listLoading,
);

export const selectFacilitiesActionLoading = createSelector(
  selectFacilitiesState,
  (facilitiesState) => facilitiesState.actionsloading,
);

export const selectLastCreatedFacilityId = createSelector(
  selectFacilitiesState,
  (facilitiesState) => facilitiesState.lastCreatedFacilityId,
);
export const selectLastCreatedFacility = createSelector(
  selectFacilitiesState,
  (facilitiesState) => facilitiesState.lastCreatedFacility,
);
export const selectFacilityErrorState = createSelector(
  selectFacilitiesState,
  (facilitiesState) => facilitiesState.error,
);

export const selectFacilitiesShowInitWaitingMessage = createSelector(
  selectFacilitiesState,
  (facilitiesState) => facilitiesState.showInitWaitingMessage,
);

export const selectFacilitiesInStore = createSelector(selectFacilitiesState, (facilitiesState) => {
  const items = (facilitiesState.ids as number[])
    .map((id) => facilitiesState.entities[id])
    .filter((item): item is FacilityModel => item !== undefined);
  return new QueryResultsModel(items, facilitiesState.totalCount);
});
